<template>
  <Dialog
    v-model:visible="localVisible"
    modal
    :header="headerMsg"
    :style="{ width: '25rem' }"
    :closable="false"
  >
    <div class="flex items-center gap-4">
      <!-- Use v-html to render HTML content in the message -->
      <span
        v-if="message"
        v-html="message"
      />
    </div>
    <template #footer>
      <Button
        v-if="!forceUpdate"
        label="Remind Me Later"
        severity="secondary"
        icon="pi pi-clock"
        @click="closeDialog"
      />
      <Button
        label="Update Now"
        severity="success"
        icon="pi pi-sync"
        @click="confirmAction"
      />
    </template>
  </Dialog>
</template>

<script>
  import { defineComponent, ref, watch } from "vue";

  export default defineComponent({
    name: "NewUpdateDialog",
    props: {
      headerMsg: {
        type: String,
        required: true
      },
      visible: {
        type: Boolean,
        required: true
      },
      message: {
        type: String,
        required: true
      },
      onConfirm: {
        type: Function,
        required: true
      },
      forceUpdate: {
        type: Boolean,
        default: false
      }
    },
    emits: ["update:visible", "confirm"],
    setup(props, { emit }) {
      const localVisible = ref(props.visible);

      // Watch the visible prop and update localVisible accordingly
      watch(
        () => props.visible,
        (newVal) => {
          localVisible.value = newVal;
        }
      );

      // Watch localVisible and emit changes to the parent
      watch(
        () => localVisible.value,
        (newVal) => {
          emit("update:visible", newVal);
        }
      );

      const closeDialog = () => {
        localVisible.value = false;
      };

      const confirmAction = () => {
        props.onConfirm();
        closeDialog();
      };

      return {
        localVisible,
        closeDialog,
        confirmAction
      };
    }
  });
</script>
